import {Timeline} from '@crema/modules/thirdParty';

export default Timeline;
